import { useCallback, useState } from "react";
import { useSalePermissions } from "../../hooks/use-sale-permissions.js";

/**
 * Feature Logic do cadeado:
 * - "Reabrir Vendas" → fluxo direto
 * - "Vendas" + isinsert → modal de solicitação
 * - sem nenhuma das duas → não age
 *
 * @param {Object} params
 * @param {(saleId: string|number, saleLike?: Object) => void} params.onDirectReopen
 */
export function useSaleReopenLockAction({ onDirectReopen } = {}) {
  const { canReopen, canRequestReopen } = useSalePermissions();
  const canShowReopenLock = canReopen || canRequestReopen;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [saleId, setSaleId] = useState(null);

  const resolveSaleId = useCallback((saleOrId) => {
    if (saleOrId == null) return null;
    if (typeof saleOrId === "object") {
      return saleOrId.idsale ?? saleOrId.idSale ?? saleOrId.id ?? null;
    }
    return saleOrId;
  }, []);

  const closeRequestModal = useCallback(() => {
    setIsModalOpen(false);
    setSaleId(null);
  }, []);

  const handleLockClick = useCallback(
    (saleOrId) => {
      const id = resolveSaleId(saleOrId);
      if (id == null) return;

      if (canReopen) {
        onDirectReopen?.(id, saleOrId);
        return;
      }

      if (canRequestReopen) {
        setSaleId(id);
        setIsModalOpen(true);
      }
    },
    [canReopen, canRequestReopen, onDirectReopen, resolveSaleId],
  );

  return {
    handleLockClick,
    canShowReopenLock,
    requestModal: {
      open: isModalOpen,
      saleId,
      onClose: closeRequestModal,
    },
  };
}
